"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_STATUS = {
    IDLE: true,
    LOADING: false,
    LOADED: false,
    ERROR: false,
};
